/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Charge_Rounding_TooltipInputs */



/**
* | output |
* | --- |
* | "Rounded up to the nearest cent, the smallest amount we can charge." |
*
* @param {Dashboard_Billing_Charge_Rounding_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_charge_rounding_tooltip = /** @type {((inputs?: Dashboard_Billing_Charge_Rounding_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Charge_Rounding_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf den nächsten Cent aufgerundet, den kleinsten Betrag, den wir abrechnen können.")
	return /** @type {LocalizedString} */ ("Rounded up to the nearest cent, the smallest amount we can charge.")
});